// facets.js — collection filters + sort. Same guard + rescan() pattern as
// drawer.js/app.js.
//
// 1. Submit-on-change: any checkbox or the sort <select> inside .facets-form
//    submits the form (plain GET, full page reload). The Apply button is the
//    no-JS fallback.
//
// 2. Mobile bottom sheet for the same <aside class="facets"> that is a static
//    sidebar on desktop (>=961px). Because the node serves both, inert/
//    aria-hidden cannot be hardcoded in the markup: syncA11y() sets them only
//    while the sheet is closed on mobile, and re-runs on resize so crossing
//    the 960px boundary keeps the state correct.
window.__tmgScrollLock = window.__tmgScrollLock || {
  n: 0, saved: '',
  lock() { if (this.n++ === 0) { this.saved = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; } },
  unlock() { if (this.n > 0 && --this.n === 0) { document.documentElement.style.overflow = this.saved; } }
};

if (!window.__tmgFacets) {
  (function () {
    var MOBILE_BP = 960;
    var toggle, panel, backdrop, closeBtn, form;
    var isOpen = false;

    function isMobile() {
      return innerWidth <= MOBILE_BP;
    }

    // Reconciles inert/aria-hidden with the current viewport + open state.
    // Safe to call any time (bind, resize, open, close).
    function syncA11y() {
      if (!panel) return;
      if (isMobile() && !isOpen) {
        panel.setAttribute('inert', '');
        panel.setAttribute('aria-hidden', 'true');
      } else {
        panel.removeAttribute('inert');
        panel.setAttribute('aria-hidden', 'false');
      }
    }

    // openPanel()/closePanel() are only ever reached via the mobile-only
    // `.facets-toggle` button (display:none >=961px, see collection.css) or
    // its Esc/backdrop/close-button equivalents, all gated on isOpen being
    // true — so the focus trap wired in here only ever engages for the
    // mobile bottom sheet, never the desktop static sidebar.
    function openPanel() {
      if (!panel) return;
      panel.classList.add('open');
      if (backdrop) backdrop.classList.add('open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      isOpen = true;
      syncA11y();
      window.__tmgScrollLock.lock();
      if (window.__tmgFocusTrap) { window.__tmgFocusTrap.trap(panel); }
      if (closeBtn) closeBtn.focus();
    }

    function closePanel() {
      if (!panel) return;
      if (!isOpen) return;
      panel.classList.remove('open');
      if (backdrop) backdrop.classList.remove('open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      isOpen = false;
      window.__tmgScrollLock.unlock();
      if (window.__tmgFocusTrap) { window.__tmgFocusTrap.release(); }
      if (toggle && toggle.offsetParent !== null) toggle.focus();
      syncA11y();
    }

    function togglePanel() {
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    }

    // Named + stable (defined once, not re-created inside bind()) so that a
    // rescan() on a form the theme editor didn't actually replace can't
    // stack duplicate listeners on the same nodes — addEventListener is a
    // no-op when the same function reference is already bound to the same
    // element+event+capture combination.
    function onAutoSubmitChange() {
      if (form) form.submit();
    }

    // (Re)bind to current DOM nodes — safe to call repeatedly, same idiom
    // as drawer.js's bind(): re-query + re-attach rather than diff.
    function bind() {
      toggle = document.querySelector('.facets-toggle');
      panel = document.getElementById('facets-panel');
      backdrop = document.querySelector('.facets-backdrop');
      closeBtn = panel ? panel.querySelector('.facets-close') : null;
      form = document.querySelector('.facets-form');
      isOpen = false;
      syncA11y();

      if (toggle) toggle.addEventListener('click', togglePanel);
      if (backdrop) backdrop.addEventListener('click', closePanel);
      if (closeBtn) closeBtn.addEventListener('click', closePanel);

      if (form) {
        var autoSubmitEls = form.querySelectorAll('select, input[type="checkbox"]');
        for (var i = 0; i < autoSubmitEls.length; i++) {
          autoSubmitEls[i].addEventListener('change', onAutoSubmitChange);
        }
      }
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closePanel();
    });
    addEventListener(
      'resize',
      function () {
        if (isOpen && !isMobile()) closePanel();
        syncA11y();
      },
      { passive: true }
    );

    function rescan() {
      bind();
    }

    document.addEventListener('shopify:section:load', function () {
      window.__tmgFacets.rescan();
    });

    bind();
    window.__tmgFacets = { rescan: rescan };
  })();
}
